import { FC } from 'react';
import {
  ProgressContainer,
  ProgressbarPart,
  ProgressbarPartContent,
} from './styled';
import { defaultTheme } from 'styles/ThemeWrapper';
import Tooltip from '../Tooltip';

type Props = {
  succeeded?: number;
  failed?: number;
  waiting?: number;
  notStarted?: number;
  cancelled?: number;
  scheduled?: number;
};

const Progressbar: FC<Props> = ({
  succeeded,
  failed,
  waiting,
  notStarted,
  cancelled,
  scheduled,
}) => {
  const total =
    (succeeded || 0) +
    (failed || 0) +
    (waiting || 0) +
    (notStarted || 0) +
    (cancelled || 0) +
    (scheduled || 0);
  const percent = (input: number) => {
    if (total === 0) {
      return 0;
    }
    const percent = 100 * (input / total);
    return percent;
  };

  const minWidth = (input: number | undefined) => {
    return !input || input === 0 ? 0 : (''+input).length*10;
  }

  const tooltipText = () => {
    let text = '';
    if (succeeded) {
      text += `succeeded: ${succeeded}\n`;
    }
    if (waiting) {
      text += `waiting: ${waiting}\n`;
    }
    if (failed) {
      text += `failed: ${failed}\n`;
    }
    if (cancelled) {
      text += `cancelled: ${cancelled}\n`;
    }
    if (scheduled) {
      text += `scheduled: ${scheduled}\n`;
    }
    return text;
  };

  if (total === 0) {
    return (
      <Tooltip paragraph={'none'}>
        <ProgressContainer>
          <ProgressbarPart width={100} color={defaultTheme.colors.grey4} minWidth={10}>
            <ProgressbarPartContent>{0}</ProgressbarPartContent>
          </ProgressbarPart>
        </ProgressContainer>
      </Tooltip>
    );
  }

  if (notStarted && notStarted > 0) {
    return (
      <Tooltip paragraph={`not started: ${notStarted}`}>
        <ProgressContainer>
          <ProgressbarPart
            width={percent(notStarted || 0)}
            color={defaultTheme.colors.grey4}
            minWidth={minWidth(notStarted)}
          >
            <ProgressbarPartContent>{notStarted}</ProgressbarPartContent>
          </ProgressbarPart>
        </ProgressContainer>
      </Tooltip>
    );
  }

  return (
    <Tooltip paragraph={tooltipText()}>
      <ProgressContainer>
        <ProgressbarPart
          width={percent(succeeded || 0)}
          color={defaultTheme.colors.success}
          minWidth={minWidth(succeeded)}
        >
          <ProgressbarPartContent>{succeeded}</ProgressbarPartContent>
        </ProgressbarPart>
        <ProgressbarPart
          width={percent(waiting || 0)}
          color={defaultTheme.colors.warning}
          minWidth={minWidth(waiting)}
        >
          <ProgressbarPartContent>{waiting}</ProgressbarPartContent>
        </ProgressbarPart>
        <ProgressbarPart
          width={percent(failed || 0)}
          color={defaultTheme.colors.error}
          minWidth={minWidth(failed)}
        >
          <ProgressbarPartContent>{failed}</ProgressbarPartContent>
        </ProgressbarPart>
        <ProgressbarPart
          width={percent(cancelled || 0)}
          color={defaultTheme.colors.grey3}
          minWidth={minWidth(cancelled)}
        >
          <ProgressbarPartContent>{cancelled}</ProgressbarPartContent>
        </ProgressbarPart>
        <ProgressbarPart
          width={percent(scheduled || 0)}
          color={defaultTheme.colors.grey5}
          minWidth={minWidth(scheduled)}
        >
          <ProgressbarPartContent>{scheduled}</ProgressbarPartContent>
        </ProgressbarPart>
      </ProgressContainer>
    </Tooltip>
  );
};

export default Progressbar;
